module.exports = __webpack_public_path__ + "static/media/WideCart_Logotext.3b545f1b.png";